import { AppPage } from '../declarations';
import { home, list, calculator, bookmarks, book, cube, settings, person, cart, desktop } from 'ionicons/icons';
import { APPLINKS } from '../resources/AppConst';
const { dashboard, company, docs, createInvoice, invoice, purchaseEntry, purchaseList, ledger, expenses, stocks, reports } = APPLINKS;


export const appPages: AppPage[] = [
    {
        title: 'Dashboard',
        url: dashboard,
        icon: home
    },
    {
        title: 'Invoices',
        url: invoice,
        icon: list
    },
    {
        title: 'Create Invoices',
        url: createInvoice,
        icon: calculator
    },

    {
        title: 'Documentation',
        url: docs,
        icon: bookmarks
    },
];
export const appAdminPages: AppPage[] = [
    {
        title: 'Dashboard',
        url: dashboard,
        icon: home
    },
    {
        title: 'Invoices',
        url: invoice,
        icon: list
    },
    {
        title: 'Create Invoices',
        url: createInvoice,
        icon: calculator
    },
    {
        title: 'Purchase Entry',
        url: purchaseEntry,
        icon: cart
    },
    {
        title: 'Purchase List',
        url: purchaseList,
        icon: desktop
    },

    {
        title: 'Customer Ledger',
        url: ledger,
        icon: book
    },
    {
        title: 'Stocks & Inventory',
        url: stocks,
        icon: cube
    },
    {
        title: 'Reports',
        url: reports,
        icon: calculator
    },
    {
        title: 'Expenses',
        url: expenses,
        icon: book
    },
    {
        title: 'Settings ',
        url: APPLINKS.settings,
        icon: settings
    },
    {
        title: 'Company Details ',
        url: company,
        icon: person
    },

    {
        title: 'Documentation',
        url: docs,
        icon: bookmarks
    },
];